import { Component, ComponentInterface, h, Host } from "@stencil/core";

/**
 * A badge component to display status information.
 *
 * @slot (default) - The content of the accordion
 */
@Component({
    tag: "ux-badge",
    styleUrl: "badge.scss",
    shadow: true
})
export class Badge implements ComponentInterface {
    render() {
        return (
            <Host role="status">
                <slot />
            </Host>
        );
    }
}
